angular.module('sdRemoteValidation', []).directive('sdRemoteValidation', ["$http", "$q", function ($http, $q) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        require: 'ngModel',
        scope: {
            model: '=ngModel',
            url: '@sdRemoteValidation'
        },
        link: function (scope, element, attrs, ctrl) {

            var efficientValidateRequest = debounce(function (deferred, modelValue) {
                if (modelValue === undefined) {
                    deferred.resolve();
                    return;
                }

                var remotePromise = $http.jsonp(scope.url, {
                    params: {
                        'value': modelValue,
                        'callback': 'JSON_CALLBACK'
                    },
                    headers: { 'useTracker': false }
                });

                remotePromise.success(function (value) {
                    if (value === false && modelValue !== '') {
                        deferred.reject();
                    } else {
                        deferred.resolve();
                    }
                });

                remotePromise.error(function () {
                    deferred.reject();
                });
            }, 500);


            var validate = function (modelValue, viewValue) {
                var deferred = $q.defer();
                efficientValidateRequest(deferred, modelValue);
                return deferred.promise;
            };

            ctrl.$asyncValidators.remote = function (modelValue, viewValue) {
                var promise = validate(modelValue);
                return promise;
            };
        }
    }
}]);
